<div class="grid-container padding-y-4">
    <div class="grid-row">
        <div class="grid-col flex-auto">
            <legend class="usa-legend usa-legend--large">FRT TSPs in Temp Non-Use</legend>
        </div>
    </div>
    <div class="grid-row">
        <ag-grid-angular class="ag-theme-alpine" style="width: 100%;" [gridOptions]="carrierRateProcurementGridOptions"
            [rowData]="rawData" [columnDefs]="carrierColumnDefs" [suppressDragLeaveHidesColumns]="true" ag-grid-resize>
        </ag-grid-angular>
    </div>
    <div class="grid-row">
        <button class="usa-button usa-button--secondary" *ngIf="closeBtnName && closeBtnName.length>0" type="button" (click)="close()">Close</button>
    </div>
</div>
